import { render, staticRenderFns } from "./study-details.vue?vue&type=template&id=f7b9d866&scoped=true&"
import script from "./study-details.vue?vue&type=script&lang=js&"
export * from "./study-details.vue?vue&type=script&lang=js&"
import style0 from "./study-details.vue?vue&type=style&index=0&id=f7b9d866&scoped=true&lang=scss&"
import style1 from "./study-details.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b9d866",
  null
  
)

component.options.__file = "study-details.vue"
export default component.exports